import * as types from './type';


const initialState = {
    propertyTypeWithAttributes: ''
};



export default function propertyTypeReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_PROPERTY_TYPES: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          propertyTypeWithAttributes: action.payload.data.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    default: {
      return {
        ...state
      };
    }
    
  }

}